// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__29KEE","title":"AfterBackImages_title__1O-f2","images":"AfterBackImages_images__dRfEU"};